import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Typography
} from "@material-ui/core";
import React, { ReactNode } from "react";
import ReactQuill from "react-quill";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import { Checkroom } from "@mui/icons-material";
import { BeachAccess } from "@material-ui/icons";
import useStyles from "./styles";
import { useTheme } from "@material-ui/core/styles";
import { Product } from "../../../../models/Product";
import { useI18n } from "../../../../hooks/useI18n";

interface Props {
  product: Product;
  onNameChange: (name: any) => void;
  onBrandChange: (brand: any) => void;
  onArticleNumberChange: (no: any) => void;
  onDescriptionChange: (description: any) => void;
}

export const ProductMainSection = ({
  product,
  onNameChange,
  onBrandChange,
  onDescriptionChange,
  onArticleNumberChange
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useI18n();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            <TextField
              style={{ width: "100%" }}
              className={classes.field}
              error={product.name === ""}
              label={t("common.formFields.productName")}
              value={product?.name}
              onChange={(e: any) => {
                onNameChange(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TextField
              style={{ width: "100%" }}
              className={classes.field}
              error={!product.brandName}
              label={t("common.formFields.brand")}
              value={product?.brandName}
              onChange={(e: any) => {
                onBrandChange(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <TextField
              style={{ width: "100%" }}
              className={classes.field}
              label={t("common.formFields.articleNumber")}
              value={product.articleNumber ?? ""}
              onChange={e => {
                onArticleNumberChange(e.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12} className={classes.productDescriptionEditor}>
            <Typography
              gutterBottom
              variant="body2"
              style={{ color: theme.palette.grey.A700 }}
            >
              {t("common.formFields.description")}
            </Typography>
            <ReactQuill
              theme="snow"
              value={product.description}
              onChange={value => {
                onDescriptionChange(value);
              }}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ list: "ordered" }, { list: "bullet" }]
                ]
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
